<div class="mtp">
  <header class="mtp__brand" aria-label="Mail assistent">
    <div class="mtp__brand-left">
      <!-- <div class="mtp__brand-mark" aria-label="Mail assistent">
        <div class="mtp__brand-graphic" aria-hidden="true"></div>
        <span class="mtp__logo-text" aria-hidden="true">
          <span class="mtp__logo-h">H</span><span class="mtp__logo-rest">OLLI</span>
        </span>
      </div> -->
      <span class="mtp__ai-badge" aria-hidden="true">AI</span>
    </div>
    <div class="mtp__brand-right">
      <button
        type="button"
        class="mtp__debug-trigger"
        (click)="openSettingsPanel()"
        aria-label="Open instellingen"
        title="Instellingen"
      >
        ⚙
      </button>
      <span class="mtp__brand-sub">Mail assistent</span>
    </div>
  </header>

  <div class="mtp__mail">
    <p class="mtp__mail-from">{{ mailStripSender() }}</p>
    <p class="mtp__mail-subject">{{ mailStripSubject() }}</p>
  </div>

  <main class="mtp__main" role="main">
    @if (holliGate() === 'holli_loading') {
      <div class="mtp__loading" role="status">
        <span class="mtp__spinner" aria-hidden="true"></span>
        <p class="mtp__loading-text">Verbinding maken met Holli…</p>
      </div>
    } @else if (holliGate() === 'sso_error') {
      <div class="mtp__empty mtp__empty--error" role="alert">
        <div class="mtp__empty-icon" aria-hidden="true">!</div>
        <p class="mtp__empty-title">Aanmelden niet mogelijk</p>
        <p class="mtp__empty-text">{{ holliSessionDetail() }}</p>
        <button type="button" class="mtp__btn mtp__btn--primary mtp__gate-retry" (click)="retryHolliSession()">
          Opnieuw proberen
        </button>
      </div>
    } @else if (holliGate() === 'tenant_denied') {
      <div class="mtp__empty mtp__empty--error" role="alert">
        <div class="mtp__empty-icon" aria-hidden="true">!</div>
        <p class="mtp__empty-title">Geen toegang</p>
        <p class="mtp__empty-text">
          Jullie Microsoft-organisatie is niet gekoppeld aan Holli voor Mail Assistent. Neem contact op met je
          beheerder of accountmanager.
        </p>
      </div>
    } @else if (holliGate() === 'session_error') {
      <div class="mtp__empty mtp__empty--error" role="alert">
        <div class="mtp__empty-icon" aria-hidden="true">!</div>
        <p class="mtp__empty-title">Inloggen mislukt</p>
        <p class="mtp__empty-text">{{ holliSessionDetail() }}</p>
        <button type="button" class="mtp__btn mtp__btn--primary mtp__gate-retry" (click)="retryHolliSession()">
          Opnieuw proberen
        </button>
      </div>
    } @else if (holliGate() === 'mailbox_setup') {
      <section class="mtp__gate" aria-labelledby="mtp-mailbox-setup-title">
        <h2 class="mtp__gate-title" id="mtp-mailbox-setup-title">Mailbox bevestigen</h2>
        <p class="mtp__gate-text">
          Bevestig je eigen mailbox voor Mail Assistent. Alleen dit account wordt gekoppeld.
        </p>
        @if (mailboxSetupLoading()) {
          <div class="mtp__loading mtp__loading--inline" role="status">
            <span class="mtp__spinner" aria-hidden="true"></span>
            <span>Mailbox wordt opgehaald…</span>
          </div>
        } @else {
          @if (mailboxesForSetup().length === 0) {
            <p class="mtp__empty-text" role="status">
              Er is geen mailbox gevonden om te koppelen. Controleer rechten in Microsoft 365 of probeer Vernieuwen.
            </p>
          } @else {
          <fieldset class="mtp__fieldset">
            <legend class="mtp__visually-hidden">Te koppelen mailbox</legend>
            @for (mb of mailboxesForSetup(); track mb.graph_user_id) {
              <label class="mtp__check-row">
                <input
                  type="checkbox"
                  [checked]="mailboxSelection()[mb.graph_user_id] === true"
                  (change)="toggleMailboxSelection(mb.graph_user_id, checkboxChecked($event))"
                />
                <span class="mtp__check-label">
                  <span class="mtp__check-title">{{ mb.display_name }}</span>
                  <span class="mtp__check-meta">{{ mb.smtp }}</span>
                </span>
              </label>
            }
          </fieldset>
          }
          @if (mailboxSetupError() !== '') {
            <p class="mtp__inline-msg mtp__inline-msg--error" role="alert">{{ mailboxSetupError() }}</p>
          }
          <div class="mtp__btn-stack mtp__gate-actions">
            <button
              type="button"
              class="mtp__btn mtp__btn--primary"
              (click)="saveMailboxSetup()"
              [disabled]="mailboxSetupSaving() || mailboxesForSetup().length === 0"
              [attr.aria-busy]="mailboxSetupSaving()"
            >
              Bevestigen en doorgaan
            </button>
            <button
              type="button"
              class="mtp__btn mtp__btn--ghost"
              (click)="retryHolliSession()"
              [disabled]="mailboxSetupSaving()"
            >
              Vernieuwen
            </button>
          </div>
        }
      </section>
    } @else if (holliGate() === 'ready') {
    @if (loading()) {
      <div class="mtp__loading" role="status">
        <span class="mtp__spinner" aria-hidden="true"></span>
        <p class="mtp__loading-text">Antwoord wordt geladen…</p>
      </div>
    } @else {
      <section class="mtp__section mtp__section--status" aria-labelledby="mtp-status-label">
        <div class="mtp__status-bar">
          <span class="mtp__section-label" id="mtp-status-label">Status</span>
          <button
            type="button"
            class="mtp__btn mtp__btn--ghost mtp__btn--compact mtp__status-refresh"
            (click)="refreshAll()"
            [disabled]="loading()"
          >
            Vernieuwen
          </button>
        </div>
        <div
          class="mtp__badge"
          [class.mtp__badge--success]="mainStatusIsSuccess()"
          [class.mtp__badge--pending]="mainStatusIsPending()"
          [class.mtp__badge--error]="mainStatusIsError()"
          [attr.aria-label]="mainStatusLabel()"
        >
          <span class="mtp__badge-dot" aria-hidden="true"></span>
          <span>{{ mainStatusLabel() }}</span>
        </div>
      </section>

      @if (mainStatusIsError()) {
        <div class="mtp__loading mtp__loading--panel mtp__loading--error" role="alert">
          <div class="mtp__error-icon" aria-hidden="true">!</div>
          <p class="mtp__loading-text mtp__loading-text--error">{{ statusErrorMessage() }}</p>
          <button type="button" class="mtp__btn mtp__btn--ghost mtp__btn--compact" (click)="refreshAll()">
            Opnieuw proberen
          </button>
        </div>
      } @else if (isHolliBusy()) {
        <div class="mtp__loading mtp__loading--panel" role="status" aria-live="polite" [attr.aria-label]="holliBusyMessage()">
          <span class="mtp__spinner" aria-hidden="true"></span>
        </div>
      } @else if (canShowProposedAnswer()) {
      <section class="mtp__section mtp__section--answer" aria-labelledby="mtp-reply-label">
        <span class="mtp__section-label" id="mtp-reply-label">Voorgesteld antwoord</span>
        <div class="mtp__answer-preview" aria-live="polite">{{ proposedAnswerPlain() }}</div>
        @if (replyActionError() !== '') {
          <p class="mtp__inline-msg mtp__inline-msg--error" role="alert">{{ replyActionError() }}</p>
        }
        @if (actionFeedback() !== '') {
          <p class="mtp__inline-msg mtp__inline-msg--ok" role="status">{{ actionFeedback() }}</p>
        }
      </section>

      <section class="mtp__section mtp__section--actions" aria-label="Acties">
        <div class="mtp__reply-actions" role="group" aria-label="Antwoord maken">
          <button
            type="button"
            class="mtp__btn mtp__btn--secondary mtp__btn--reply"
            (click)="createReplyDraft('reply')"
            [disabled]="!canCreateReplyDraft()"
          >
            Beantwoorden
          </button>
          <button
            type="button"
            class="mtp__btn mtp__btn--secondary mtp__btn--reply"
            (click)="createReplyDraft('reply_all')"
            [disabled]="!canCreateReplyDraft()"
          >
            Allen beantwoorden
          </button>
        </div>
        <div class="mtp__btn-stack">
          <button type="button" class="mtp__btn mtp__btn--ghost" (click)="dismissReply()">
            Afwijzen
          </button>
        </div>
      </section>
      }
    }
    }
  </main>

  <footer class="mtp__footer">
    <span class="mtp__footer-muted">Powered by</span>
    <a
      class="mtp__footer-brand"
      href="https://holli.nl/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Holli
    </a>
  </footer>
</div>

@if (settingsPanelOpen()) {
  <div class="mtp-dim" role="presentation">
    <button
      type="button"
      class="mtp-dim__backdrop"
      (click)="closeSettingsPanel()"
      tabindex="-1"
      aria-label="Sluit instellingen"
    ></button>
    <div class="mtp-modal" role="dialog" aria-modal="true" aria-labelledby="mtp-settings-title">
      <header class="mtp-modal__head">
        <h2 class="mtp-modal__title" id="mtp-settings-title">Instellingen</h2>
        <button type="button" class="mtp-modal__close" (click)="closeSettingsPanel()">Sluiten</button>
      </header>
      <div class="mtp-modal__body" tabindex="-1">
        <section class="mtp-settings__block" aria-labelledby="mtp-settings-status-title">
          <h3 class="mtp-settings__title" id="mtp-settings-status-title">Status</h3>
          @if (webhookStatusLoading()) {
            <p class="mtp-settings__hint" role="status">Status laden…</p>
          }
          @if (webhookStatusError() !== '') {
            <p class="mtp-settings__error" role="alert">{{ webhookStatusError() }}</p>
          }
          <ul class="mtp-settings__list">
            <li class="mtp-settings__row">
              <span class="mtp-settings__label">Holli-account</span>
              <span
                class="mtp__badge"
                [class.mtp__badge--success]="settingsHolliLoggedIn()"
                [class.mtp__badge--pending]="!settingsHolliLoggedIn()"
              >
                <span class="mtp__badge-dot" aria-hidden="true"></span>
                <span>{{ settingsHolliLoggedIn() ? 'Ingelogd' : 'Uitgelogd' }}</span>
              </span>
            </li>
            @if (settingsUserEmail() !== '') {
              <li class="mtp-settings__row">
                <span class="mtp-settings__label">Mailbox</span>
                <span class="mtp-settings__value">{{ settingsUserEmail() }}</span>
              </li>
            }
            <li class="mtp-settings__row">
              <span class="mtp-settings__label">Webhook-koppeling</span>
              <span
                class="mtp__badge"
                [class.mtp__badge--success]="settingsWebhookIsHealthy()"
                [class.mtp__badge--pending]="!settingsWebhookIsHealthy() && !settingsWebhookIsError()"
                [class.mtp__badge--error]="settingsWebhookIsError()"
              >
                <span class="mtp__badge-dot" aria-hidden="true"></span>
                <span>{{ settingsWebhookLabel() }}</span>
              </span>
            </li>
            @if (webhookStatus()?.next_expiration_at) {
              <li class="mtp-settings__row">
                <span class="mtp-settings__label">Verloopt op</span>
                <span class="mtp-settings__value">{{ webhookNextExpirationReadable() }}</span>
              </li>
            }
            <li class="mtp-settings__row">
              <span class="mtp-settings__label">Geselecteerde mail</span>
              <span
                class="mtp__badge"
                [class.mtp__badge--success]="statusMailSelected()"
                [class.mtp__badge--pending]="!statusMailSelected()"
              >
                <span class="mtp__badge-dot" aria-hidden="true"></span>
                <span>{{ statusMailSelected() ? 'Ja' : 'Nee' }}</span>
              </span>
            </li>
          </ul>
        </section>

        <section class="mtp-settings__block" aria-labelledby="mtp-settings-actions-title">
          <h3 class="mtp-settings__title" id="mtp-settings-actions-title">Acties</h3>
          @if (settingsFeedback() !== '') {
            <p class="mtp-settings__banner" role="status">{{ settingsFeedback() }}</p>
          }
          <div class="mtp-settings__actions">
            <button
              type="button"
              class="mtp__btn mtp__btn--secondary"
              (click)="unsubscribeFromOutlook()"
              [disabled]="unsubscribeLoading() || logoutLoading()"
              [attr.aria-busy]="unsubscribeLoading()"
            >
              Ontkoppelen van mailbox
            </button>
            <button
              type="button"
              class="mtp__btn mtp__btn--ghost"
              (click)="logoutFromHolli()"
              [disabled]="logoutLoading() || unsubscribeLoading() || !settingsHolliLoggedIn()"
              [attr.aria-busy]="logoutLoading()"
            >
              Uitloggen bij Holli
            </button>
          </div>
          <p class="mtp-settings__hint">
            Ontkoppelen stopt de webhook voor nieuwe mails. Uitloggen beëindigt je Holli-sessie in deze add-in.
          </p>
        </section>
      </div>
    </div>
  </div>
}
